import { IActivity } from '@sdk/contracts';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { useActivityPreview } from '@/hooks';

type Props = {
  activity: IActivity;
};

export const PreviewActivity: React.FC<Props> = ({ activity }) => {
  const { setActivityId } = useActivityPreview();
  const { t } = useTranslation('DefaultTranslations');
  const handlePreviewActivity = () => {
    setActivityId(activity._id);
  };

  return (
    <Tooltip title={t('PREVIEW_FILE')}>
      <Button
        type="text"
        icon={<Icon i="DocumentView" size={20} />}
        onClick={handlePreviewActivity}
      />
    </Tooltip>
  );
};
